import { useMemo } from "react";
import { useNavigationHistory } from "../store";
import dayjs from "dayjs";
import { formattingDurationResult } from "../utils";

export const useCalculateTotalTravelTime = () => {
  const navigationHistory = useNavigationHistory();

  const { startLocation, endLocation } = navigationHistory || {};

  return useMemo(() => {
    const startTime = dayjs(startLocation?.timestampUtc);
    const finishTime = dayjs(endLocation?.timestampUtc);
    const durationTime = dayjs.duration(finishTime.diff(startTime));

    return formattingDurationResult(durationTime);
  }, [endLocation?.timestampUtc, startLocation?.timestampUtc]);
};
